import { Clear } from "@mui/icons-material"
import { Grid, IconButton, Tooltip } from "@mui/material"
import { ChipTag } from "./styles"
import { rootStore } from "stores/root-store"
import { format, isValid } from "date-fns"
import { exceptionTypeLabels } from "shared/constants/sale-order-constant"

export const FilterTags = ({ data = [], onDelete, onClick }) => {
  const formatDate = val => {
    if (val) {
      if (typeof val === "string") return format(new Date(val), "yyyy-MM-dd")
      else if (isValid(val)) return format(val, "yyyy-MM-dd")
    }
    return ""
  }
  const getDateFilterText = val => {
    if (!val || !val.mode) return ""

    let res = ""
    switch (val.mode) {
      case "TODAY":
        res += "today"
        break
      case "YESTERDAY":
        res += "yesterday"
        break
      case "LAST_3_DAYS":
        res += "last 3 days"
        break
      case "LAST_7_DAYS":
        res += "last 7 days"
        break
      default:
        if (val.before_date && val.after_date) {
          if (val.before_date) res += ` From ${formatDate(val.before_date)}`
          if (val.after_date) {
            res += ` To ${formatDate(val.after_date)}`
          }
        } else if (val.before_date) res += ` Before ${formatDate(val.before_date)}`
        else if (val.after_date) res += ` After ${formatDate(val.after_date)}`
    }
    return res
  }
  const getLabel = item => {
    let val = item.val
    let label = ""
    const boolItems = ["active", "id8000", "marine_pollutant", "personal_care", "lithium_battery", "hide_lines_no_soh", "including_inventory"]
    switch (item.name) {
      case "archival_search":
        val = val ? "Archival search" : ""
        break
      case "before_date":
        label = "Filter date"
        val = getDateFilterText(val)
        break
      /*case "after_date":
        label = "After"
        val = formatDate(val)
        break*/
      case "search_term":
        label = "Keywords"
        break
      case "sku":
      case "order_status":
      case "warehouse":
      case "sales_channel":
      case "carrier":
        if (item.name == "sku") label = "SKU Codes"
        if (Array.isArray(val)) val = val.join(",")
        break
      case "exception_type":
        val = (Array.isArray(val) ? val : [val]).map(value => exceptionTypeLabels[value] || value).join(",")
        break
      case "country":
        if (Array.isArray(val)) {
          val = val.map(v => rootStore.getTextByValue("COUNTRY", v)).join(",")
        } else {
          val = val ? rootStore.getTextByValue("COUNTRY", val) : val
        }

        break
      case "item_category1":
        label = "Category 1"
        break
      case "item_category2":
        label = "Category 2"
        break
      case "item_category3":
        label = "Category 3"
        break
      case "packing_group":
        label = "Packing Group"
        break
      default:
        if (boolItems.includes(item.name)) val = item.text
        break
    }
    return !val ? "" : label ? `${label}: ${val}` : val
  }

  return (
    <Grid container rowSpacing={1} columnSpacing={1}>
      {data?.map(item => {
        if (
          !item.val ||
          item.val == "ALL" ||
          (Array.isArray(item.val) && item.val.length === 0) ||
          (item.val.mode == "CUSTOM" && !item.val.before_date && !item.val.after_date) ||
          (item.name == "before_date" && !item.val.mode)
        )
          return
        const key = item.name

        return (
          <Grid item key={key}>
            <ChipTag
              variant="outlined"
              key={key}
              label={getLabel(item)}
              onDelete={() => {
                onDelete?.(key)
              }}
              deleteIcon={
                <Tooltip placement="top" title="Remove">
                  <IconButton id={`remove-filter-${key}`}>
                    <Clear fontSize="small" color="inherit" />
                  </IconButton>
                </Tooltip>
              }
              onClick={() => onClick(item)}
            ></ChipTag>
          </Grid>
        )
      })}
    </Grid>
  )
}
